import { t } from 'src/lib/language';
import { makeStyles } from '@material-ui/core/styles';
import { Store } from 'src/redux/Store';
import { useSelector } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import { useEffect, useState } from 'react';

const useStyles = makeStyles(() => ({
  header: {
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
    fontSize: '1.8rem',
    fontFamily: 'Qanelas-Bold',
    height: '48px',
    marginTop: '16px',
  },
  row: {
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    gap: '10px',
    marginBottom: '16px',
  },
}));

interface Props {
  titleKey: string,
}

const SubscriptionDatagridHeader = (props: Props) => {
  const { titleKey } = props;
  const classes = useStyles();

  const lang = useSelector((state: Store) => state.language.language);
  const subscriptionId = useSelector((state: Store) => Number(state.route.id || 0));
  const subscription = useSelector((state: Store) => state.subscriptions[subscriptionId]);
  const [title, setTitle] = useState('');

  const getTitle = () => {
    if (!subscription) return '';
    if (!subscription.title) return `#${subscription.id}`;
    return `${subscription.title} (#${subscription.id})`;
  };

  useEffect(() => {
    setTitle(getTitle());
    if (!subscription) return;
    document.title = `${t(lang, titleKey)}: ${getTitle()}`;
  }, [subscription]);

  return (
    <div className={classes.header}>
      <div className={classes.row}>
        <Typography
          variant="h5"
          color="secondary"
          gutterBottom
          className={classes.header}>
          {t(lang, titleKey)} {title}
        </Typography>
      </div>
    </div>
  );
};

export default SubscriptionDatagridHeader;
